module.exports = __webpack_public_path__ + "static/img/aboutUs_banner.9d5f3a1.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/index/aboutUs_banner.png
// module id = /VHe
// module chunks = 1